export const environment = {
  production: false,
  serviciosFront: 'https://servicios.bitwan.info/',
  googleApiKey: 'AIzaSyBJUnzRS-9L6X2_nSglcAY9dCBBHo1SJgA',
  url: 'https://cobertura.bitwan.info/api/v1',
  apiVentas: 'https://pruebatres.bitwan.info/v1/'
};
